import { z } from "zod";

/**
 * The note open beside the list, as Inbox names its open item. Apart from `schemas.ts`, so the
 * route's search check does not bring the feature's words into every screen's first load.
 */
export const notesSearch = z.object({
  note: z.string().optional().catch(undefined),
});
